import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";

import { App, createApp, ref } from "vue";
import VueApp from "./App.vue";
import { setupRouter } from "./router";
import { UserState } from "./userState";
import { AuthControl, AuthControlImpl } from "./authControl";

import { setupCookieConsent } from "./composables/cookieConsent";
import { createPhotosService } from "./services/photosService";

import TextClamp from 'vue3-text-clamp';
import vue3GoogleLogin from 'vue3-google-login'
import VueSanitize from 'vue-sanitize-directive'
import { provideAdminServices, provideServices } from "./services";
import { createGoogleService } from "./services/googleService";

setupCookieConsent();

const userState = ref<UserState>({
  loading: 1,
  isSignedIn: false
});

const apiServer = import.meta.env.VITE_ERTP_API_SERVER;
const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

const googleService = createGoogleService();
googleService.loadGoogle();

const authControl: AuthControl = new AuthControlImpl(userState);
const router = setupRouter(userState.value, authControl);

function setupAppDependencies(app: App<Element>) {
  app.provide('userState', userState);
  app.provide('authControl', authControl);

  app.provide('googleService', googleService);

  const photosService = createPhotosService(
    authControl,
    googleService
  );
  app.provide('photosService', photosService);

  provideServices(app, apiServer, authControl);

  provideAdminServices(app, apiServer, authControl);


  app.use(vue3GoogleLogin, {
    clientId: googleClientId,
    buttonConfig: {
      text: "continue_with"
    }
  });

  app.use(TextClamp);
  app.use(VueSanitize);
    
};

const app = createApp(VueApp);
setupAppDependencies(app);
app.use(router);
app.mount("#app");


